export default __webpack_public_path__ + "static/media/denomination.4f49011e.svg";